import { Image } from 'primereact/image';
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import Layout from "../../../components/common/nav/initiator/nav.component";
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { DataStore,  SortDirection } from 'aws-amplify';
import ReactFullscreen from "react-easyfullscreen";
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../../assets/images/sidebarright.svg"
import Editpopup from "../../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../../setup/auth/login.component';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { GetValueFromArray } from '../../../helper/commonfunctions';
import {
  Employee, Schools, SubstituteCertificateRequest, SubstituteCertificateRequestAccountNoIDs, SubstituteCertificateRequestTransactionCycle, CertificatedAdminWeeklyAbsenceReportStatus, TypeOfSubRequestOrObjectCode, StipendMaster, StipendTransactionCycle, SemisterMaster, YearMaster, StipendAssignments
} from "../../../models";
import moment from "moment";
import { Link } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { toast } from 'react-toastify';
import { FilterMatchMode, } from 'primereact/api';
import { reactLocalStorage } from 'reactjs-localstorage';
import '../../../components/reportpdftemplate/base.min.css'
import '../../../components/reportpdftemplate/fancy.min.css'
import '../../../components/reportpdftemplate/main.css'
import { USER_TYPES, USER_TYPES_NAMES, Request_Stipend_Status,stipend_Type } from '../../../helper/enum';
import { useReactToPrint } from "react-to-print";
import StipendFormPdf from '../../../components/reportpdftemplate/stipendFormPDF';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default function StipendApproverReportList() {

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  

  //*state
  const [assignmentTitle, setAssignmentTitle] = useState('');
  const [employeeCode, setEmployeeCode] = useState();
  const [classification, setClassification] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [endTime, setEndTime] = useState('');
  const [startTime, setStartTime] = useState('');
  var [toDate, setToDate] = useState('');
  const [typeOfSubRequest, setTypeOfSubRequest] = useState('');
  const [location, setLocation] = useState('');
  const [reasonForAbsenceRequest, setReasonForAbsenceRequest] = useState('');
  const [totalWorkingHours, setTotalWorkingHours] = useState('');
  const [substituteName, setSubstituteName] = useState('');
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [principalAndDepartmentHead, setPrincipalAndDepartmentHead] = useState('');
  const [budgetApprover, setBudgetApprover] = useState('');
  const [payrollHR, setPayrollHR] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [substituteReportId, setSubstituteReportId] = useState("");
  const [rejectReportId, setRejectReportId] = useState("");
  const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
  const [signature, setSignature] = useState(true);
  const [needMoreApprovals, setNeedMoreApprovals] = useState(false);
  const [checkedSignature, setCheckedSignature] = useState(false);
  const [selectedEmployeeForApprovals, setSelectedEmployeeForApprovals] = useState(null);
  const [showNeedMoreApprovals, setShowNeedMoreApprovals] = useState(false);
  const [rejectVisible, setRejectVisible] = useState(false);
  const [popUpToEmployeeID, setPopUpToEmployeeID] = useState("");
  const [popUpFromEmployeeID, setPopUpFromEmployeeID] = useState("");
  const [sendMsg, setSendMsg] = useState(false);
  const [rejectMsgValue, setRejectValueMsg] = useState('');
  const [confirmedValue, seConfirmedValue] = useState('');
  const [assignmentNameDisplay, seAssignmentNameDisplay] = useState('');
  const [employeeDetailsName, setEmployeeDetailsName] = useState('');
  const [isApproveButtonDisable, setIsApproveButtonDisable] = useState(false);
  const [isCheckFromEmployeeId, setIsCheckFromEmployeeId] = useState(false);
  const [secondApprovalFromEmployeeId, setSecondApprovalFromEmployeeId] = useState("");
  const [secondApprovalToEmployeeId, setSecondApprovalToEmployeeId] = useState("");
  const [isSubmittedCount1, setIsSubmittedCount1] = useState("");
  const [isApproveCount1, setIsApproveCount1] = useState("");
  const [isRejectCount1, setIsRejectCount1] = useState("");
  const [isSubmittedCount2, setIsSubmittedCount2] = useState("");
  const [isApproveCount2, setIsApproveCount2] = useState("");
  const [isRejectCount2, setIsRejectCount2] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoader, setIsLoader] = useState(true);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [confirmVisibleApprove, setConfirmVisibleApprove] = useState(false);
  // const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmited']);

  const [statuses] = useState(['Acknowledged', Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL, 'Pending for Budget Approver', 'Pending For PayrollHR', "Rejected"])
  const [statusesPayrolls] = useState(['Acknowledged', 'Pending For PayrollHR']);
  //*list
  const [principleDepartmentHeadList, setPrincipleDepartmentHeadList] = useState([]);
  const [payrollListHR, setPayrollListHR] = useState([]);

  const [substituteRequestClassifiedReportListInitiator, setSubstituteRequestClassifiedReportListInitiator] = useState([]);

  const [substituteRequestClassifiedReportListApproval, setSubstituteRequestClassifiedReportListApproval] = useState([]);

  const [accountNoArray, setAccountNoArray] = useState([{
    "accountNo": ""
  }]);


  //states start
  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
  const [stipendReportDetails, setStipendReportDetails] = useState([]);
  const [schoolYearId, setSchoolYearId] = useState('');
  const [semisterId, setSemisterId] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [departmentPeopleCount, setDepartmentPeopleCount] = useState('');
  const [assignmentArray, setAssignmentArray] = useState([{
    "name": "", "amount": ""
  }]);
  const [selectedConfirmation, setSelectedConfirmation] = useState([]);


  //states end
  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [activate, setActivate] = useState("");
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);

  const [filters, setFilters] = useState({
    assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dates: { value: null, matchMode: FilterMatchMode.CONTAINS },
    schoolName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    designation: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const handleClickDisable = () => {
    // Set the state to indicate that the button has been clicked
    setButtonClicked(true);
  };

  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false); setConfirmVisibleApprove(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
    </div>
  );

  //_____popup

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [status, setStatus] = useState('');
  const [userloggedRole, setUserRole] = useState("");

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [assighnmentTitle, setClassificationTitle] = useState('');

  const objectCodeArray = [
    { name: 'Code 1', code: TypeOfSubRequestOrObjectCode.CODE1 },
    { name: 'Code 2', code: TypeOfSubRequestOrObjectCode.CODE2 },
    { name: 'Code 3', code: TypeOfSubRequestOrObjectCode.CODE3 }
  ];

  const confirmed = stipend_Type;

  const TaskStatusSL = (product) => {
    switch (product.designation) {
      case 'Reviewed & resubmitted':
        return 'info';

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Pending for Principal/Department Head':
        return 'warning';

      case 'Pending for Budget Approver':
        return 'warning';

      case 'Pending For PayrollHR':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Acknowledged':
        return 'success';

      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';
        case 'Completed-(step 9)':
          return 'success';
      default:
        return null;
    }
  };

  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };


  const statusRowFilterTemplatePayroll = options => {

    return (
      <Dropdown
        value={options.value}
        options={statusesPayrolls}
        onChange={e => options.filterApplyCallback(e.value)}
        //onChange={e => callbackE(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select"
        className="p-column-filter custDropdown"
        showClear
        style={{ minWidth: "7rem" }}
      />
    );
  };

  const TaskStatusSLA = (product) => {
    return <Tag value={product.designation} severity={TaskStatusSL(product)}></Tag>;
  };

  
  const generatePDF = (fileName) => {
    console.log(fileName+'fileNamefileName')
    const input = document.getElementById('my-html-template');
    html2canvas(input)
        .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF(
                // {
                //     orientation: "landscape",
                //     unit: "in",
                //     // format: [4, 2]
                // }
            );

            pdf.addImage(imgData, 'PNG', 5, 5);
            pdf.setDisplayMode('fullwidth', 'continuous');

            pdf.save(fileName+'.pdf');
        });
    }
    

  const getLoggRole = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    //get logged user role
    let adminUsers;
    if (loggedUserId) {
      try {
        adminUsers = await cognito.adminGetUser({
          UserPoolId: awsmobile.aws_user_pools_id,
          Username: loggedUserId,
        }).promise();
      } catch (e) {
        //console.log(e)
      }
    }
    let loggedUserRole = adminUsers.UserAttributes.find(attr => attr.Name === "custom:role")?.Value;
    let role = loggedUserRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : loggedUserRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : loggedUserRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I
    console.log(loggedUserRole)
    setUserRole(role)
  }

  const onClickEditPopUp = async (data) => {
    var requestId = data.id; setSubstituteReportId(requestId);
    SetPreviewAndEdit(false);
    SetBasicInfoPopUp(true);
    const cognito = new AWS.CognitoIdentityServiceProvider();
    const substituteCertificateRequestTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, requestId);

    if (substituteCertificateRequestTransactionCycleResponse.status === "APPROVAL_REJECTED") { setRejectReportId("Rejected"); }
    else if (substituteCertificateRequestTransactionCycleResponse.status === "SUBMITTED") { setRejectReportId("Submitted"); }
    else if (substituteCertificateRequestTransactionCycleResponse.status === "RESUBMITTED") { setRejectReportId("Reviewed & resubmitted"); }

    setShowNextPopUp(true);
    const substituteCertificateRequestResponse = await DataStore.query(StipendMaster, (c) => c.id.eq(substituteCertificateRequestTransactionCycleResponse.report_Id));
    const employeeCodeResponse = await DataStore.query(Employee, (c) => c.id.eq(substituteCertificateRequestResponse[0].employeeId));

    setEmployeeDetailsName(employeeCodeResponse[0].employee_name)
    setEmployeeCode({ name: employeeCodeResponse[0].employee_name + " (" + employeeCodeResponse[0].employee_code + ")", code: employeeCodeResponse[0].id });


    if (substituteCertificateRequestResponse[0].substitudeName.length > 0) {
      if (substituteCertificateRequestResponse[0].isConfirmed === true) { seConfirmedValue("Yes") } else
        if (substituteCertificateRequestResponse[0].isConfirmed === false) { seConfirmedValue("No") }
    }
    else { seConfirmedValue("") }


    setAssignmentTitle(substituteCertificateRequestResponse[0].assignmentTitle); setClassification(substituteCertificateRequestResponse[0].classification);

    let fromDate = new Date(moment(substituteCertificateRequestTransactionCycleResponse.date).format("YYYY-MM-DD")); setFromDate(fromDate);
    let toDate = substituteCertificateRequestTransactionCycleResponse.date && substituteCertificateRequestTransactionCycleResponse.date !== null ? new Date(moment(substituteCertificateRequestTransactionCycleResponse.date).format("YYYY-MM-DD")) : ''; setToDate(toDate);

    console.log("substituteCertificateRequestResponse", substituteCertificateRequestResponse)
    if (substituteCertificateRequestTransactionCycleResponse.date) {
      const formattedDate = new Date(moment(`2023/07/12 ${substituteCertificateRequestTransactionCycleResponse.date}`).format("YYYY-MM-DD HH:mm:ss.SSS"));
      //setEndTime(formattedDate)
      setEndTime(substituteCertificateRequestTransactionCycleResponse.date)
    }

    if (substituteCertificateRequestTransactionCycleResponse.date) {
      const formattedDate = new Date(moment(`2023/07/12 ${substituteCertificateRequestTransactionCycleResponse.date}`).format("YYYY-MM-DD HH:mm:ss.SSS"));
      //setStartTime(formattedDate)
      setStartTime(substituteCertificateRequestTransactionCycleResponse.date)
    }


    setReasonForAbsenceRequest(substituteCertificateRequestTransactionCycleResponse.remark);

    setSubstituteName(substituteCertificateRequestResponse[0].substitudeName);
    setTotalWorkingHours(substituteCertificateRequestResponse[0].totalWorkingHours)

    const locationResponse = await DataStore.query(Schools, (c) => c.id.eq(substituteCertificateRequestResponse[0].locationId)); setLocation({ name: locationResponse[0].name, code: locationResponse[0].id });
    if (substituteCertificateRequestResponse[0].typeOfSub === "CODE1") { setTypeOfSubRequest({ name: "Code 1", code: substituteCertificateRequestResponse[0].typeOfSub }) }
    else if (substituteCertificateRequestResponse[0].typeOfSub === "CODE2") { setTypeOfSubRequest({ name: "Code 2", code: substituteCertificateRequestResponse[0].typeOfSub }) }
    else if (substituteCertificateRequestResponse[0].typeOfSub === "CODE3") { setTypeOfSubRequest({ name: "Code 3", code: substituteCertificateRequestResponse[0].typeOfSub }) }
    //get Principle Department Head 
    let principalDepartmentHead;
    if (substituteCertificateRequestResponse[0].principalId) {
      try {
        principalDepartmentHead = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: substituteCertificateRequestResponse[0].principalId, }).promise();
      } catch (e) {
        //console.log(e)
      }
    }
    let firstApprovalFirstName = await GetValueFromArray(principalDepartmentHead.UserAttributes, "custom:firstName")
    let firstApprovalLastName = await GetValueFromArray(principalDepartmentHead.UserAttributes, "custom:lastName")
    let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName
    let objFirst = { name: fullFirstName, code: substituteCertificateRequestResponse[0].principalId }
    setPrincipalAndDepartmentHead(objFirst)

    //get Budget Approver
    let budgetApproverSet;
    if (substituteCertificateRequestResponse[0].hrTechI) {
      try {
        budgetApproverSet = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: substituteCertificateRequestResponse[0].hrTechI, }).promise();
      } catch (e) {
        //console.log(e)
      }
    }

    if (substituteCertificateRequestResponse[0].hrTechI) {
      let secoundApproverFirstName = await GetValueFromArray(budgetApproverSet.UserAttributes, "custom:firstName")
      let secoundApproverLastName = await GetValueFromArray(budgetApproverSet.UserAttributes, "custom:lastName")
      let fullFirstsName = secoundApproverFirstName + " " + secoundApproverLastName
      let objFirsts = { name: fullFirstsName, code: substituteCertificateRequestResponse[0].hrTechI }
      setBudgetApprover(objFirsts)

    }

    //get Payroll Approver
    let payrollHrSet;
    if (substituteCertificateRequestResponse[0].executiveManagerId) {
      try {
        payrollHrSet = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: substituteCertificateRequestResponse[0].executiveManagerId, }).promise();
      } catch (e) {
        //console.log(e)
      }
    }
    let thirdApproverFirstName = await GetValueFromArray(payrollHrSet.UserAttributes, "custom:firstName")
    let thirdApproverLastName = await GetValueFromArray(payrollHrSet.UserAttributes, "custom:lastName")
    let fullThirdName = thirdApproverFirstName + " " + thirdApproverLastName
    let objThird = { name: fullThirdName, code: substituteCertificateRequestResponse[0].executiveManagerId }
    setPayrollHR(objThird)

    console.log("objThird", objThird);
    console.log("objThird--", substituteCertificateRequestResponse);

    //*get Account Numbers
    setAccountNoArray([])
  }

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });


  const requestedReportAction = (row) => {

    return (
      <div className="flex justify-center w-full gap-2">
        {
          row.status === 'Pending for Approval' || row.status === 'Pending for approval' ?
            <Link to='' className="py-2 px-2.5"
              // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
              onClick={() => {
                onClickRequestedReportEditPopUp(row)
              }}
            ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
            row.status === 'Approved' || row.designation === 'Acknowledged' ?
              <Link to='' className="py-2 px-2.5" onClick={() => {
                onClickRequestedReportViewPopup(row, 'right')
              }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.designation === 'Rejected' ?
                <Link to='' className="py-2 px-2.5" onClick={() => {
                  onClickRequestedReportViewPopup(row, 'right')
                }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                null
        }
      </div >
    );
  };

  //action layout code start
  const initiateReportAction = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >

        {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => {
            setIsUpdate(true);
            onClickEditPopUp(row);
          }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
            row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => {
              setIsUpdate(true);
              onClickEditPopUp(row);
            }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
              row.status === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL || row.designation === 'Acknowledged' ? <Link to='#' className="py-2 px-2.5" onClick={() => {
                onClickRequestedReportViewPopup(row, 'right');
              }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                row.status === "Rejected" ? <Link to='#' className="py-2 px-2.5"
                  onClick={() => {
                    setIsUpdate(true);
                    onClickEditPopUp(row);
                  }}
                ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
                  <Link to='#' className="py-2 px-2.5"
                    onClick={() => {
                      setIsUpdate(true);
                      onClickEditPopUp(row);
                    }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        }
      </div>
    );
  };

  const requestReportStatusOptions = (product) => {

    switch (product.designation) {
      case 'Reviewed & resubmitted':
        return 'info';

      case 'Rejected':
        return 'danger';

      case 'Pending for Principal/Department Head':
        return 'warning';

      case 'Pending for Budget Approver':
        return 'warning';

      case 'Pending For PayrollHR':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case 'Acknowledged':
        return 'success';

      case 'Approved (P)':
        return 'success';
        case 'Completed-(step 9)':
          return 'success';
      default:
        return null;
    }
  };


  const payrollStatusOptions = product => {
    switch (product.status) {
      case "Pending for Acknowledge":
        return "warning";

      case "Acknowledged":
        return "success";


      case 'Rejected':
        return 'danger';

      case 'Closed':
        return 'success';
        case 'Completed-(step 9)':
          return 'success';
      default:
        return null;
    }
  };

  const requestReportStatus = (product) => {
    return <Tag value={product.designation} severity={requestReportStatusOptions(product)}></Tag>;
  };

  const payrollStatusBody = product => {
    return <Tag value={product.designation} severity={requestReportStatusOptions(product)}></Tag>;
  };

  const approvalStatusBody = (product) => {
    let pstatus = product.status === 'APPROVAL_ACCEPTED' ? "Approved" : product.status
    return <Tag value={pstatus} severity={approveStatusOptions(product)}></Tag>;
  };

  const approveStatusOptions = (product) => {

    console.log("product", product);

    switch (product.status) {
      case 'Rejected':
        return 'danger';

      case 'APPROVAL_REJECTED':
        return 'danger';

      case 'Acknowledged':
        return 'success';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL:
        return 'warning';

      case 'Closed':
        return 'success';
      case 'Approved':
        return 'success';

      case 'APPROVAL_ACCEPTED':
        return 'success';

      case 'RESUBMITTED':
        return 'info';

      case 'SUBMITTED':
        return 'info';

      case 'Submitted':
        return 'info';

      case 'Reviewed & resubmitted':
        return 'info';
        case 'Completed':
          return 'success';
        case 'Completed-(step 9)':
          return 'success';
      default:
        return null;
    }
  };

  //approve report function
  const approveSelectedReport = async (reportId, status) => {

    //get reporting manager from SixthPeriodAssignmentInitiateReport table
    if (status === "APPROVAL_ACCEPTED") {
      try {

        //get particular report id metadata from CertificatedSubInitiateRequest table
        const CertificatedSubInitiateRequestResponse = await DataStore.query(SubstituteCertificateRequest, (c) => c.id.eq(reportId));

        //first update CertificatedSubRequestTransactionCycle particular report id entry.
        const original = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.reportId.eq(reportId), {
          sort: (s) => s.createdAt(SortDirection.DESCENDING)
        });

        if (original) {
          const updatedPost = await DataStore.save(
            SubstituteCertificateRequestTransactionCycle.copyOf(original[0], updated => {
              updated.status = status;
              updated.isApproved = true;
              updated.date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          );

          if (updatedPost.id) {
            if (CertificatedSubInitiateRequestResponse) {

              let firstApprover = CertificatedSubInitiateRequestResponse[0].principleDepartmentHeadString;
              let secondApprover = CertificatedSubInitiateRequestResponse[0].budgetApprover;
              let payroll = CertificatedSubInitiateRequestResponse[0].payrollHr;

              //check if logger user is first or second or third approver
              var toEmployee;

              switch (loggedUserId) {
                case firstApprover:
                  if (secondApprover) {
                    toEmployee = secondApprover;
                  } else {
                    toEmployee = payroll;
                  }
                  break;
                case secondApprover:
                  toEmployee = payroll;
                  break;
                default:
                  //means logged in user is Payroll
                  toEmployee = 'no further';
                  break;
              }


              try {
                //after we add entry in CertificatedSubRequestTransactionCycle table

                const CertificatedSubRequestTransactionCycleResponse = await DataStore.save(new SubstituteCertificateRequestTransactionCycle(
                  {
                    reportId: reportId,
                    fromEmployeeId: loggedUserId,
                    toEmployeeId: toEmployee,
                    status: CertificatedAdminWeeklyAbsenceReportStatus.SUBMITTED,
                    isApproved: false,
                    date: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                  }
                ));

              }
              catch (err) {
                console.log("error---", err)
              }
            }

          } else {
            toast.error('Something Went Wrong...');
          }
          setIsLoader(true)
          BindList();
          setConfirmVisibleApprove(true)
          setVisibleRequestedReportEdit(false);


        }
      }
      catch (err) {

      }
    }

    else if (status === "APPROVAL_REJECTED") {
      try {
        const transactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.reportId.eq(reportId));
        const original = await DataStore.query(SubstituteCertificateRequestTransactionCycle, transactionCycleResponse[0].id);
        await DataStore.save(
          SubstituteCertificateRequestTransactionCycle.copyOf(original, (updated) => {
            updated.status = status;
            updated.remark = rejectMsgValue;
            updated.date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
          })
        ).then(async (response) => {
          setRejectValueMsg("");
          BindList();
        })
      }
      catch (err) {
      }
    }
    setSelectedEmployeeForApprovals(null)
    setIsApproveButtonDisable(false);
  }

  const approveSelectedReportFrom = async (reportId, status, toEmployeeId, fromEmployeeId) => {

    try {
      var transactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.and(c => [
        c.reportId.eq(reportId),
        c.toEmployeeId.eq(toEmployeeId),
        c.fromEmployeeId.eq(fromEmployeeId),
      ]));
      const original = await DataStore.query(SubstituteCertificateRequestTransactionCycle, transactionCycleResponse[0].id);
      await DataStore.save(
        SubstituteCertificateRequestTransactionCycle.copyOf(original, (updated) => {
          updated.status = status;
          updated.date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        })
      ).then(async (response) => {
        BindList();

      })
    }
    catch (err) {
    }
    setVisibleRequestedReportEdit(false);
    setSelectedEmployeeForApprovals(null)
    setIsApproveButtonDisable(false);


  }

  const rejectSelectedReportFrom = async (reportId, status, toEmployeeId, fromEmployeeId) => {

    try {
      var transactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.and(c => [
        c.reportId.eq(reportId),
        c.toEmployeeId.eq(toEmployeeId),
        c.fromEmployeeId.eq(fromEmployeeId),
      ]));
      // const transactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.reportId.eq(reportId));
      const original = await DataStore.query(SubstituteCertificateRequestTransactionCycle, transactionCycleResponse[0].id);
      await DataStore.save(
        SubstituteCertificateRequestTransactionCycle.copyOf(original, (updated) => {
          updated.status = status;
          updated.remark = rejectMsgValue;
          updated.date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        })
      ).then(async (response) => {
        setRejectValueMsg("");
        BindList();
      })
    }
    catch (err) {
    }
    // setVisibleRequestedReportEdit(false);
    setSelectedEmployeeForApprovals(null)
    setIsApproveButtonDisable(false);
  }

  const needMoreApproveSelectedReport = async (status, reportId, fromEmployeeId, toEmployeeId) => {

    await DataStore.save(
      new SubstituteCertificateRequestTransactionCycle({
        "reportId": reportId,
        "fromEmployeeId": fromEmployeeId,
        "toEmployeeId": toEmployeeId,
        "status": status,
        "isApproved": false,
        "remark": "",
        "date": moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      })
    ).then(() => {
      BindList();
      setVisibleRequestedReportEdit(false);
      setSelectedEmployeeForApprovals(null)
      setIsApproveButtonDisable(false);
    })
  }

  const onClickRequestedReportEditPopUp = async (requestData) => {

    const cognito = new AWS.CognitoIdentityServiceProvider();
    SetPreviewAndEdit(false);
    SetBasicInfoPopUp(true);
    setIsCheckFromEmployeeId(requestData.isCheckFromEmployeeId);
    setSecondApprovalFromEmployeeId(requestData.fromEmployeeId);
    setSecondApprovalToEmployeeId(requestData.toEmployeeId)

    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub;
    let fullName;
    let userCodeEmp;
    let locationName;
    users.forEach((user, i) => {
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );

    //*get substitute request data
    const substituteCertificateRequestResponse = await DataStore.query(SubstituteCertificateRequest, (c) => c.id.eq(requestData.id));
    let toEmployeeID = substituteCertificateRequestResponse[0].createdBy; setPopUpToEmployeeID(toEmployeeID); setPopUpFromEmployeeID(loggedUserId);
    const locationResponse = await DataStore.query(Schools, (c) => c.id.eq(substituteCertificateRequestResponse[0].locationId));
    locationName = locationResponse[0].name


    var finalArray = [];
    const accountNumberResponse = await DataStore.query(SubstituteCertificateRequestAccountNoIDs, (c) => c.substituteCertificateRequestId.eq(requestData.id));
    accountNumberResponse.map((item, index) => {
      let data = {
        "accountNumber": item.accountNumber,
      }
      finalArray.push(data)
    })

    console.log("finalArray", finalArray);


    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle,
        (c) => c.reportId.eq(requestData.id),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );
      let adminUsers;
      if (particularReportTransactionCycleResponse[0].toEmployeeId) {
        try {
          adminUsers = await cognito.adminGetUser({
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: particularReportTransactionCycleResponse[0].toEmployeeId,
          }).promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let userFirstName = await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName")
      let userLastName = await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName")
      userCodeEmp = await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode")
      fullName = userFirstName + " " + userLastName

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].toEmployeeId) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
          }
          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestEditPopUp", err);
    }
    //---End Approval Status-------

    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------

    setVisibleRequestedReportEdit(true);

    //set Data for View Popup
    let obj = {
      id: requestData.id,
      employeeName: fullName,
      employee_id: userCodeEmp,
      assighment_at: locationName,
      from_date: substituteCertificateRequestResponse[0].fromDate,
      to_date: substituteCertificateRequestResponse[0].toDate & substituteCertificateRequestResponse[0].toDate !== null ? substituteCertificateRequestResponse[0].toDate : '',
      subject_area: substituteCertificateRequestResponse[0].reasonForAbsenceRequest,
      totalWorkingHours: substituteCertificateRequestResponse[0].totalWorkingHours,
      fromTime: substituteCertificateRequestResponse[0].fromTime,
      endTime: substituteCertificateRequestResponse[0].endTime,
      confirmationStatus: substituteCertificateRequestResponse[0].isConfirmed,
      typeofSub: substituteCertificateRequestResponse[0].typeOfSub,
      substituteName: substituteCertificateRequestResponse[0].substitudeName,
      location: locationName,
      classification: substituteCertificateRequestResponse[0].classification,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      approvalFinalData: approvalFinalData,
      accountNoArray: finalArray,
    }

    setSpecificReportDetailsEdit(obj);

    //check specific report =>transaction cycle length is greter than 3
    try {
      let sixthPeriodReportTransactionCycleResponseLate = await DataStore.query(SubstituteCertificateRequestTransactionCycle,
        (c) => c.reportId.eq(requestData.id), { sort: (s) => s.createdAt(SortDirection.DESCENDING) });

      const sixthPeriodReportTransactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle,
        (c) => c.reportId.eq(requestData.id));
      if (sixthPeriodReportTransactionCycleResponse.length >= 3) {
        setNeedMoreApprovals(true);
      }
      //loop to get last status

      if (sixthPeriodReportTransactionCycleResponse.length >= 3) {
        let countCycle = false;
        for (let i = 0; i < 3; i++) {
          if (sixthPeriodReportTransactionCycleResponseLate[i].status === "ReviewedResubmitted") {
            if (i === 2) {
              setNeedMoreApprovals(true)
              countCycle = true
            } else {
              setNeedMoreApprovals(false)
              setSignature(false)
              setCheckedSignature(true)
            }
          }

        }

        let reviewList = sixthPeriodReportTransactionCycleResponseLate.filter(item => item.status === "ReviewedResubmitted");
        if (reviewList.length >= 1) {
          //setSignature(false)
          //setCheckedSignature(true)
        }
        if (countCycle) {
          setSignature(true)
          setCheckedSignature(false)
        }
      }
    } catch (err) {
      console.log("ERROR in request Edit function");
    }


  }

  //* onclick view popup
  const onClickRequestedReportViewPopup = async (requestData, position) => {

    const cognito = new AWS.CognitoIdentityServiceProvider();


    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub;
    users.forEach((user, i) => {
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );

    // console.log("APPP newResnewRes:-", newRes)

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    let formHistoryFinalData = [];
    let fullName;
    let userCodeEmp;
    let locationName;

    try {
      const particularReportTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, (c) => c.id.eq(requestData.id),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

    console.log('particularReportTransactionCycleResponse' + JSON.stringify(particularReportTransactionCycleResponse))


      const substituteCertificateRequestResponse = await DataStore.query(StipendMaster, (c) => c.id.eq(particularReportTransactionCycleResponse[0].report_Id),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

      console.log('requestDatasubstituteCertificateRequestResponse' + JSON.stringify(substituteCertificateRequestResponse))


      const employee = await DataStore.query(Employee, substituteCertificateRequestResponse[0].employeeId);
      const school = await DataStore.query(Schools, substituteCertificateRequestResponse[0].schoolId);
      const schoolYear = await DataStore.query(YearMaster, substituteCertificateRequestResponse[0].schoolYearId);
      const semister = await DataStore.query(SemisterMaster, substituteCertificateRequestResponse[0].semisterId);
      // setBtnStatus(substituteCertificateRequestResponse.status)
      if (substituteCertificateRequestResponse.isMiddleStipend === true) {
        setSelectedConfirmation([{ name: 'Middle School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isMiddleStipend' }])
      } else if (substituteCertificateRequestResponse.isElementaryStipend === true) {
        setSelectedConfirmation([{ name: 'Elementary Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isElementaryStipend' }])
      } else if (substituteCertificateRequestResponse.isHighStipend === true) {
        setSelectedConfirmation([{ name: 'High School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isHighStipend' }])
      } else if (substituteCertificateRequestResponse.isDepartmentStipend === true) {
        setSelectedConfirmation([{ name: 'Department Chair Stipend(01.0-00000.0-11303-10000-1170-0005616)(01.0-65000.0-57606-11100-1170-0000600-SPED)', key: 'isDepartmentStipend' }])
      } else if (substituteCertificateRequestResponse.isHeadStipend === true) {
        setSelectedConfirmation([{ name: 'Head Counselor Stipend(01.0-00000.0-00000-31101-1272-0004682)', key: 'isHeadStipend' }])
      }

      let assignments = await DataStore.query(StipendAssignments, (c) => c.stipendMasterId.eq(substituteCertificateRequestResponse[0].id));

      var myArray = [];
      if (assignments.length > 0) {
        for (let i = 0; i < assignments.length; i++) {
          myArray.push({ "name": assignments[i].name, "amount": assignments[i].amount })
        }
        setAssignmentArray(myArray)
      }

      if (employee)
        setEmployeeId({ "name": employee.employee_name + " (" + employee.employee_code + ")", "code": employee.id })
      if (school)
        setLocation({ "name": school.name, "code": school.id })
      if (schoolYear)
        setSchoolYearId({ "name": schoolYear.name, "code": schoolYear.id })
      if (semister)
        setSemisterId({ "name": semister.name, "code": semister.id })

      const locationResponse = await DataStore.query(Schools, (c) => c.id.eq(substituteCertificateRequestResponse[0].schoolId));
      locationName = locationResponse[0].name

      let adminUsers='';
      if (particularReportTransactionCycleResponse[0].to_Employee_Id) {
        try {
          adminUsers = await cognito.adminGetUser({
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: particularReportTransactionCycleResponse[0].to_Employee_Id,
          }).promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let userFirstName = await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName")
      let userLastName = await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName")
      userCodeEmp = await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode")
      fullName = userFirstName + " " + userLastName
      let obj = { name: fullName, code: particularReportTransactionCycleResponse[0].to_Employee_Id }

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let status = "";

          //*check Need to approval
          var needToApprovalTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, (c) => c.and(c => [
            c.report_Id.eq(requestData.id),
            c.from_employeeId.eq(particularReportTransactionCycleResponse[i].to_Employee_Id)
          ]));


          if (needToApprovalTransactionCycleResponse.length > 0) {
            status = "Approved";
          } else {
            status = particularReportTransactionCycleResponse[i].status === "APPROVAL_ACCEPTED" ? "Approved" : particularReportTransactionCycleResponse[i].status === "APPROVAL_REJECTED" ? "Rejected" : particularReportTransactionCycleResponse[i].status === "RESUBMITTED" ? "Reviewed & resubmitted" : particularReportTransactionCycleResponse[i].status === "SUBMITTED" ? "Pending For Approval" : "Pending for Approval"
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: status
          }

          //form history remark 
          if (particularReportTransactionCycleResponse[i].status === 'Rejected') {

            let obj = {
              empName: empName,
              remarkType: 'Rejected',
              empRemark: particularReportTransactionCycleResponse[i].remark
            };

            formHistoryFinalData.push(obj);
          }

          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestViewPopup", err);
    }
    //---End Approval Status-------


    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------


    setPosition(position);
    setVisible(true);


    let obj = {
      id: requestData.id,
      employeeName: fullName,
      employee_id: userCodeEmp,
      assighment_at: locationName,
      from_date: '',
      to_date: '',
      subject_area: '',
      totalWorkingHours: '5',
      fromTime: '',
      endTime: '',
      confirmationStatus: 'Yes',
      typeofSub: '',
      substituteName: '',
      location: locationName,
      classification: '',
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      approvalFinalData: approvalFinalData,
      accountNoArray: [],
      formHistoryFinalData: formHistoryFinalData,
    }
    setSpecificReportDetailsView(obj);
  }


  //Get Weekly Absence Report-Classified List
  const BindList = async () => {

    //*load Substitute Certificate Request 
    loadSubstituteCertificateRequest();
    /* loadSubstituteCertificateRequestApproval(); */
    setIsLoader(false)
  }

  //*loadAbsenceReport
  const loadSubstituteCertificateRequest = async () => {

    const substituteCertificateRequestResponse = await DataStore.query(StipendMaster, (c) => c.principalId.eq(loggedUserId),
      { sort: s => s.createdAt(SortDirection.DESCENDING) }
    );

    console.log(JSON.stringify(loggedUserId), 'loggedUserId')
    console.log(JSON.stringify(substituteCertificateRequestResponse), 'substituteCertificateRequestResponse')


    let finalArray = [];

    for (let i = 0; i < substituteCertificateRequestResponse.length; i++) {

      let principalAndDepartmentHead = substituteCertificateRequestResponse[i].principalId;
      let budgetApprover = substituteCertificateRequestResponse[i].hrTechI;
      let payrollHr = substituteCertificateRequestResponse[i].executiveManagerId;

      let date = substituteCertificateRequestResponse[i].createdAt !== null ? moment(substituteCertificateRequestResponse[i].createdAt).format('MM/DD/YYYY') : '-';

      const substituteCertificateRequestTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, (c) => c.and(c => [
        c.report_Id.eq(substituteCertificateRequestResponse[i].id) //,c.status.eq(Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL)
      ]), { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

      let sixthPeriodReportTransactionCycleResponseLate = await DataStore.query(
        StipendTransactionCycle,
        c => c.report_Id.eq(substituteCertificateRequestResponse[i].id),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

      let toEmployeeId = sixthPeriodReportTransactionCycleResponseLate.length
        ? sixthPeriodReportTransactionCycleResponseLate[0].to_Employee_Id
        : 0;

      let designation = "";
      switch (toEmployeeId) {
        case principalAndDepartmentHead:
          designation = "Pending for Principal/Department Head";
          break;
        //reporting manager.
        case budgetApprover:
          designation = "Pending for Budget Approver";
          break;
        case payrollHr:
          designation = "Pending For PayrollHR";
          break;
      }

      let semisterName = '';

      if (substituteCertificateRequestResponse[i].semisterId) {
        const semister = await DataStore.query(SemisterMaster, substituteCertificateRequestResponse[i].semisterId);
        semisterName = semister.name;
      }

      const sortedRecords = substituteCertificateRequestTransactionCycleResponse.sort((a, b) => new Date(b.date) - new Date(a.date));
      var status = ""; var remark = ""; var index = 1;

      console.log("sortedRecords", sortedRecords);

      if (sortedRecords.length > 0) {

        for (let i = 0; i < sortedRecords.length; i++) {

          if (sortedRecords[i].status === "OPEN") { designation = "Pending"; remark = "-"; }
          else if (sortedRecords[i].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL) { status = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL; remark = sortedRecords[i].remark; }
          else if (sortedRecords[i].status === "Acknowledge") { designation = "Acknowledged"; remark = "-"; }
          else if (sortedRecords[i].status === "APPROVAL_REJECTED") { designation = "Rejected"; remark = sortedRecords[i].remark; }
          else if (sortedRecords[i].status === "RESUBMITTED") { status = "Reviewed & resubmitted"; remark = sortedRecords[i].remark; }

          let data = {
            "id": sortedRecords[i].id,
            "assignmentTitle": semisterName,
            "dates": date,
            "submittedOn": sortedRecords[i].date === "" ? "-" : moment(sortedRecords[i].date).format("MM/DD/YYYY"),
            "status": sortedRecords[i].status,
            "designation": sortedRecords[i].status,
            "remark": remark,
            "sLNo": i + 1
          }
          finalArray.push(data)
        }

      }
      if (i === substituteCertificateRequestResponse.length - 1) {
        const sortedArray = finalArray.sort((a, b) => new Date(b.submittedOn) - new Date(a.submittedOn));
        let submittedCount = finalArray.filter((item) => item.status === "Submitted"); setIsSubmittedCount1(submittedCount.length);
        let approvalCount = finalArray.filter((item) => item.status === "Approved"); setIsApproveCount1(approvalCount.length)
        let rejectedCount = finalArray.filter((item) => item.status === "Rejected"); setIsRejectCount1(rejectedCount.length)


        // sortedArray.reverse()
        setSubstituteRequestClassifiedReportListInitiator(sortedArray)
        setIsLoader(false)
      }
    }

  }

  /* const loadSubstituteCertificateRequestApproval = async () => {

    var substituteCertificateRequestTransactionCycleResponse = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.and(c => [
      c.toEmployeeId.eq(loggedUserId),

    ], { sort: s => s.createdAt(SortDirection.DESCENDING) }));

    let finalArray = [];
    if (substituteCertificateRequestTransactionCycleResponse.length > 0) {
      for (let i = 0; i < substituteCertificateRequestTransactionCycleResponse.length; i++) {

        if (substituteCertificateRequestTransactionCycleResponse[i].status === "OPEN") {
          continue
        }

        const substituteCertificateRequestResponse = await DataStore.query(SubstituteCertificateRequest, (c) => c.id.eq(substituteCertificateRequestTransactionCycleResponse[i].reportId));

        let principalAndDepartmentHead = substituteCertificateRequestResponse[0].principleDepartmentHeadString;
        let budgetApprover = substituteCertificateRequestResponse[0].budgetApprover;
        let payrollHr = substituteCertificateRequestResponse[0].payrollHr;


        let sixthPeriodReportTransactionCycleResponseLate = await DataStore.query(
          SubstituteCertificateRequestTransactionCycle,
          c => c.reportId.eq(substituteCertificateRequestResponse[0].id),
          { sort: s => s.createdAt(SortDirection.DESCENDING) }
        );

        let toEmployeeId = sixthPeriodReportTransactionCycleResponseLate.length
          ? sixthPeriodReportTransactionCycleResponseLate[0].toEmployeeId
          : 0;

        let designation = "";
        switch (toEmployeeId) {
          case principalAndDepartmentHead:
            designation = "Pending for Principal/Department Head";
            break;
          //reporting manager.
          case budgetApprover:
            designation = "Pending for Budget Approver";
            break;
          case payrollHr:
            designation = "Pending For PayrollHR";
            break;
        }



        var status = ""; var remark = ""; var index = 1; var isCheckFromEmployeeId = false;
        let createdByValue = substituteCertificateRequestResponse[0].createdBy;

        if (createdByValue === substituteCertificateRequestTransactionCycleResponse[i].fromEmployeeId) {
          isCheckFromEmployeeId = true;
        } else {
          isCheckFromEmployeeId = false;
        }


        if (substituteCertificateRequestTransactionCycleResponse[i].status === "SUBMITTED") {
          // status = "Pending for Approval";
          var substituteCertificateRequestTransactionCycleResponseTwo = await DataStore.query(SubstituteCertificateRequestTransactionCycle, (c) => c.and(c => [
            c.fromEmployeeId.eq(loggedUserId),
            c.reportId.eq(substituteCertificateRequestTransactionCycleResponse[i].reportId)
          ]));


          if (substituteCertificateRequestTransactionCycleResponseTwo.length > 0) {
            status = "Approved"; remark = "-";
          } else {
            status = "Pending for Approval"; remark = "-";
          }
        }
        else if (substituteCertificateRequestTransactionCycleResponse[i].status === "APPROVAL_ACCEPTED") { status = "Approved"; remark = "-"; }

        else if (substituteCertificateRequestTransactionCycleResponse[i].status === "Acknowledge") { designation = "Acknowledged"; remark = "-"; }

        else if (substituteCertificateRequestTransactionCycleResponse[i].status === "APPROVAL_REJECTED") {
          designation = "Rejected";
          remark = substituteCertificateRequestTransactionCycleResponse[i].remark;
        }
        else if (substituteCertificateRequestTransactionCycleResponse[i].status === "RESUBMITTED") { status = "Pending for Approval"; remark = "-"; }

        let date = moment(substituteCertificateRequestResponse[0].fromDate).format("MM/DD/YYYY") + " to " + (substituteCertificateRequestResponse[0].toDate && substituteCertificateRequestResponse[0].toDate !== null ? moment(substituteCertificateRequestResponse[0].toDate).format("MM/DD/YYYY") : '-')
        // remark = substituteCertificateRequestTransactionCycleResponse[i].remark === "" ? "-" : substituteCertificateRequestTransactionCycleResponse[i].remark


        let data = {
          "id": substituteCertificateRequestResponse[0].id,
          "assignmentTitle": substituteCertificateRequestResponse[0].assignmentTitle,
          "dates": date,
          "submittedOn": substituteCertificateRequestResponse[0].CreatedByDateTime === "" ? "-" : moment(substituteCertificateRequestResponse[0].CreatedByDateTime).format("MM/DD/YYYY"),
          "status": status,
          "designation": designation,
          "submittedOnTime": substituteCertificateRequestTransactionCycleResponse[i].createdAt,
          "remark": remark,
          "sLNo": index,
          "isCheckFromEmployeeId": isCheckFromEmployeeId,
          "fromEmployeeId": substituteCertificateRequestTransactionCycleResponse[i].fromEmployeeId,
          "toEmployeeId": substituteCertificateRequestTransactionCycleResponse[i].toEmployeeId,
        }
        finalArray.push(data)
        if (i === substituteCertificateRequestTransactionCycleResponse.length - 1) {
          const sortedArray = finalArray.sort((a, b) => new Date(b.submittedOnTime) - new Date(a.submittedOnTime));
          let submittedCount = finalArray.filter((item) => item.status === "Submitted"); setIsSubmittedCount2(submittedCount.length);
          let approvalCount = finalArray.filter((item) => item.status === "Approved"); setIsApproveCount2(approvalCount.length);
          let rejectedCount = finalArray.filter((item) => item.status === "Rejected"); setIsRejectCount2(rejectedCount.length);
          //sortedArray.reverse()

          setSubstituteRequestClassifiedReportListApproval(sortedArray);
          setIsLoader(false)
        }
      }
    } else {
      setSubstituteRequestClassifiedReportListApproval([]);
      setIsLoader(false)
    }

  } */

 

  const loadUsers = () => {
    //------------------------------- load users-------------
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        // console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
        (data.Users).forEach((user, i) => {
          userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
          userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
          userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
          userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
          sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
          let obj = {
            "userId": sub,
            "name": userName,
            "email": userEmail,
            "usercode": userCode,
            "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
          }
          newRes.push(obj);
        }
        );

        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get('loggedUserId');


        newRes.map((currentItem) => {
          if (currentItem.role !== 'Admin' && currentItem.role !== 'Payroll'
            && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        })

        //set employee list
        let finalEmployeeList = [];

        usersWithoutAdminAndLoggedUser.map((currentItem) => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
        })

        //set Payroll list
        let finalPayrollList = [];

        const payrollers = newRes.filter(user => user.role === 'Payroll');
        payrollers.map((currentItem) => {
          let objPayroll = { name: currentItem.name, code: currentItem.userId };
          finalPayrollList.push(objPayroll);
        })

        setPayrollListHR(finalPayrollList)
        setPrincipleDepartmentHeadList(finalEmployeeList);
        setEmployeeList(finalEmployeeList)
        getLoggRole();

      }
    });
  }

  const footerContentForReqReject = () => (
    <div className='text-center'>

      {
        (sendMsg) ?
          <button className='bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded' onClick={() => {
              BindList();
              setRejectVisible(false);
              setVisibleRequestedReportEdit(false);
              setSendMsg(false);
            }}>Ok</button> :


          <button className='bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded' onClick={() => {
              approveSelectedReport(specificReportDetailsEdit.id, CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_REJECTED);
              BindList();
              setRejectVisible(false);
              // setVisibleRequestedReportEdit(false);
              setSendMsg(false);
              setVisibleRequestedReportEdit(false);
            }}>Send</button>
      }


    </div>
  );

  useEffect(() => {
    //  onLoad();
    loadUsers();
    BindList();
  }, [assignmentNameDisplay, employeeCode]);


  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (
          <Layout pageTitle="Report" activeMenu="Initiator" appId="STIPEND_FORM">
            <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
              <div className="flex justify-end visible lg:hidden">
                <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                    <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                      <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Stipend Form</p>

                      {
                        activeIndex === 0 && userloggedRole !== USER_TYPES_NAMES.P ?
                          <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                            <Link onClick={() => {
                              onToggle();
                            }} to=""> <i className="gusd-expand"></i></Link>
                          </div> : null
                      }

                    </div>

                    {
                      userloggedRole === USER_TYPES_NAMES.P ?
                        <TabView activeIndex={activeIndex} onTabChange={(e) => {
                          setActiveIndex(e.index)
                        }}>
                          <TabPanel header="Payroll">
                            <div className={substituteRequestClassifiedReportListApproval.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                              <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                                filters={filters}
                                filterDisplay="row"
                                value={substituteRequestClassifiedReportListApproval}
                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                              // selectionMode='checkbox' selection={selectedReports} onSelectionChange={(e) => setSelectedReports(e.value)} dataKey="srNo"
                              >
                                {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                                <Column field="sLNo" header="SL#" style={{ minWidth: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                                <Column field="assignmentTitle" filters header="Semester" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                                <Column field="dates" header="Created Date" filter filterPlaceholder="Search" sortable></Column>
                                <Column field="submittedOn" filters header="Submitted on" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                                <Column field="designation" filter header="Status" body={payrollStatusBody} filterElement={statusRowFilterTemplatePayroll} sortable style={{ minWidth: '8rem' }}></Column>
                                <Column field="remark" header="Remarks" style={{ minWidth: '5rem' }}></Column>
                                <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={requestedReportAction} style={{ minWidth: '6rem' }}></Column>
                              </DataTable>
                            </div>
                          </TabPanel>
                        </TabView>
                        :
                        <TabView activeIndex={activeIndex} onTabChange={(e) => {
                          setActiveIndex(e.index)
                        }}>
                          <TabPanel header="Stipend Reports">
                            <div className={substituteRequestClassifiedReportListInitiator.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                              <DataTable
                                className="custpaginator custIcons custmBtnTable custTable"
                                scrollable
                                filters={filters}
                                filterDisplay="row"
                                value={substituteRequestClassifiedReportListInitiator}
                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                                emptyMessage="No records found."
                              >
                                <Column field="sLNo" header="SL#" style={{ minWidth: '3rem' }}></Column>
                                <Column field="assignmentTitle" header="Semester" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                                <Column field="dates" filter filterPlaceholder="Search" header="Created Date" sortable></Column>
                                <Column field="submittedOn" header="Submitted On" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                                <Column header="Status" field="designation" filter filterElement={statusRowFilterTemplate} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                <Column field="remark" header="Remarks" align='center' filterPlaceholder="Search by Assignment Remarks" style={{ minWidth: '6rem' }}></Column>
                                <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={initiateReportAction} style={{ minWidth: '6rem' }}></Column>
                              </DataTable>
                            </div>
                          </TabPanel>
                        </TabView>

                    }

                    <Dialog className="relative reports-popup" visible={visible} position={position}
                      style={{ width: `${(fullViewForView) ? '50vw' : '60vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() =>
                        setVisible(false)
                      } draggable={false} resizable={false}>
                      <div className="grid grid-cols-1 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-12 bg-[#F5F6F7] h-auto">
                          <div className="p-5">
                            <div onClick={() => setVisible(false)} className="py-3">
                              <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                            {
                              (!fullViewForView) ?
                                <div>
                                  <div className='text-center'>
                                    <div><b>GLENDALE UNIFIED SCHOOL DISTRICT</b></div>
                                    <div className="text-[#344054] text-xs lg:text-[0.833vw] font-medium">Request For Approval - Stipend Form</div>
                                  </div>
                                </div> : null
                            }

                            <div className="rounded-[8px] p-3 mt-3">

                              {
                                (!fullViewForView) ?
                                  <div className='flex justify-between'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipend Req.pdf</div>
                                    <button onClick={() => setFullViewForView(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                  </div> :
                                  <div className='flex justify-between'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipend_Form.pdf</div>
                                    <button onClick={() => setFullViewForView(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                  </div>
                              }

                              {
                                (!fullViewForView) ?
                                  <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] h-10'>
                                    {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}

                                    <div id="my-html-template" className='border-2 px-8'>
                                      {/* <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                                        <div>Glendale, California</div>
                                        <div style={{ marginTop: '20px' }}><b>Advance request for stipend form</b></div>
                                         <div className='border w-full text-[12px] mt-4'>
                                          DIRECTIONS:This form is to be completed and routed according to the approval signature(s) sequence below when requesting a stipend.
                                        </div> </center>*/}
                                      <div className='w-full text-[12px] mt-4'>
                                        <StipendFormPdf ref={componentRef}
                                          data={{
                                            'schoolName': location.name,
                                            'schoolYear': schoolYearId.name,
                                            'schoolSemister': semisterId.name,
                                            'employeeName': employeeId.name,
                                            'departmentTypeName': departmentId.name,
                                            'departmentCount': departmentPeopleCount,
                                            'assignmentArray': assignmentArray,
                                            'stipendTypes': confirmed,
                                            'selectedConfirmation': selectedConfirmation,
                                          }}
                                        />
                                      </div>

                                    </div>
                                  </div> :
                                  <div className="grid grid-cols-1 ">
                                    {/* <img src={pdfImage} alt='myImg' /> */}

                                    <StipendFormPdf ref={componentRef}
                                      data={{
                                        'schoolName': location.name,
                                        'schoolYear': schoolYearId.name,
                                        'schoolSemister': semisterId.name,
                                        'employeeName': employeeId.name,
                                        'departmentTypeName': departmentId.name,
                                        'departmentCount': departmentPeopleCount,
                                        'assignmentArray': assignmentArray,
                                        'stipendTypes': confirmed,
                                        'selectedConfirmation': selectedConfirmation,
                                      }}
                                    />
                                  </div>
                              }
                              <div className='bg-white'>
                                <div className='grid grid-cols-2 gap-4 absolute bottom-2 left-4 right-4'>
                                  <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#FFF] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                    <i className="mr-3 gusd-print-outline"></i><span className='printicon' onClick={handlePrint}>Print</span>
                                  </div>

                                  <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center" onClick={generatePDF("stipend")} >
                                    <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog>

                    <Dialog header="Approve" visible={confirmVisibleApprove} style={{ width: '30vw' }} onHide={() => { setConfirmVisibleApprove(false); setVisibleRequestedReportEdit(false); }} footer={footerContent}  >
                      <p className="m-0 text-[#0487C8] text-center">
                        <i className='pi pi-check-circle mr-2'></i>
                        <span className='font-medium text-[18px]'>This report is Approved</span>
                      </p>
                    </Dialog>

                    {/* confirmation dialog */}

                    <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                      <p className="m-0 text-[#0487C8]">
                        <i className='pi pi-check-circle mr-2'></i>
                        <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                      </p>
                    </Dialog>
                    {/* edit popup end */}

                  </div>

                  <Sidebar visible={visibleRight} position="right" onHide={() =>
                    setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                    <Editpopup popupstate={() => setVisibleRight(false)}
                      fromDate={fromDate}
                      toDate={toDate}
                      schoolName={schoolName}
                      reportEmployeeList={reportEmployeeList}
                      status={status}
                      reportId={reportId}
                      // bindList={() => loadAbsenceReport()}
                      type={"Initior"}
                    />

                  </Sidebar>
                </div>
              </div >
            </div >

            {/* next full popup */}
            < Dialog blockScroll={true} className="relative reports-popup" visible={showNextPopUp} position="right" style={{ width: '100vw' }
            } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setShowNextPopUp(false)} draggable={false} resizable={false} >

              {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
              < div className="fixed z-10 inset-0 styled-select" >

                <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
                  <div className="relative transform transition-all w-full">
                    <div className="grid grid-cols-12 custmCols">
                      <div className="col-span-3 h-full sideBarLeft openSideDiv">
                        <button onClick={() => { setShowPreviewPopUp(false); setShowNextPopUp(false) }} type="button" className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md" id="add-family-cancel-btn"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home</button>
                        <div className="mt-[16px] xl:mt-[0.833vw] text-[#101828] text-[24px] xl:text-[0.933vw] font-normal">Stipend Form</div>
                        <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">{assignmentNameDisplay}</div>
                        <div className="mt-[32px] xl:[1.667vw]">
                          <ul className="sideTabs">
                            <li><a href="#"
                              onClick={() => { setShowPreviewPopUp(false); SetPreviewAndEdit(false); SetBasicInfoPopUp(true) }} className={`${basicInfoPopUp === true ? "tab-b active activeCheck" : ""}`} data-id="tab1">
                              <i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>
                              Basic Info</a></li>

                            <li><a href="#"
                              onClick={() => { SetBasicInfoPopUp(false); SetPreviewAndEdit(true) }}
                              className={`${previewAndEdit === true ? "tab-b active activeCheck" : null}`}
                              data-id="tab2"><i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit</a></li>

                          </ul>
                        </div>
                        <div className="fixed top-0 left-0 openBtn xl:hidden">
                          <button type="button" className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"><i className="gusd-arrow-line-right"></i></button>
                        </div>
                      </div>


                      {/* confirmation dialog */}

                     
                    </div>
                  </div>
                </div>

              </div >
            </Dialog >

            {/* Reject dialog */}
            < Dialog header="Reject Report" visible={rejectVisible} style={{ width: '30vw' }} onHide={() => {
              setRejectVisible(false);
              setVisibleRequestedReportEdit(false)

            }} footer={footerContentForReqReject} >
              <div className="m-0">
                {
                  (!sendMsg) ?
                    <div className='font-medium text-[18px] mb-6'>Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>
                    :
                    <div className='font-medium text-[18px] text-[#249144] mb-6'>Message Sent Successfully</div>
                }
                <InputText value={rejectMsgValue} placeholder="Enter the Reason for Rejection" onChange={(e) => setRejectValueMsg(e.target.value)} className="w-full" />
              </div>
            </Dialog >



          </Layout >
        )}
      </ReactFullscreen >
    </>

  ) : (
    <Login sessionExpired={1} />
  );
}